import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchWFourCancel = createAsyncThunk("fetchWFourCancel", async ({ id }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`wfour/cancel?id=${id}`, config);
	message.success("W-Four has been deleted successfully!");
	return response.data;
});

const wFourCancelSlice = createSlice({
	name: "wFourCancel",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	reducers: {
		w4CancelResetState: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchWFourCancel.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchWFourCancel.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchWFourCancel.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { w4CancelResetState } = wFourCancelSlice.actions;
export default wFourCancelSlice.reducer;
